var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"type",attrs:{"contenteditable":"true"},domProps:{"textContent":_vm._s(_vm.inputText)},on:{"blur":_vm.handleInput}})])}
var staticRenderFns = []

export { render, staticRenderFns }